export function initCanvasFx(containerId) {
    const container = document.getElementById(containerId);
    if (!container) return;
    
    // Respect user preference for reduced motion
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    // Check if canvas already exists to avoid duplicates
    let canvas = container.querySelector('canvas.hero-canvas');
    if (!canvas) {
        canvas = document.createElement('canvas');
        canvas.className = 'hero-canvas';
        canvas.style.position = 'absolute';
        canvas.style.top = '0';
        canvas.style.left = '0';
        canvas.style.width = '100%';
        canvas.style.height = '100%';
        canvas.style.pointerEvents = 'auto'; // allow mouse interaction
        canvas.style.zIndex = '0'; 
        
        if (getComputedStyle(container).position === 'static') {
            container.style.position = 'relative';
        }
        
        container.insertBefore(canvas, container.firstChild);
    }

    const ctx = canvas.getContext('2d');
    let width, height;
    let particles = [];
    
    // Mouse tracking
    let mouse = {
        x: null,
        y: null,
        radius: 150
    };

    container.addEventListener('mousemove', function(event) {
        const rect = canvas.getBoundingClientRect();
        mouse.x = event.clientX - rect.left;
        mouse.y = event.clientY - rect.top;
    });

    container.addEventListener('mouseleave', function() {
        mouse.x = null;
        mouse.y = null;
    });

    function resize() {
        width = container.offsetWidth;
        height = container.offsetHeight;
        canvas.width = width;
        canvas.height = height;
        initParticles();
    }
    
    window.addEventListener('resize', resize);

    class Particle {
        constructor() {
            this.x = Math.random() * width;
            this.y = Math.random() * height;
            // random direction and slow speed
            this.vx = (Math.random() - 0.5) * 0.8;
            this.vy = (Math.random() - 0.5) * 0.8;
            // varying sizes
            this.size = Math.random() * 3.0 + 1.0;
            // base color varies slightly
            this.baseColor = Math.random() > 0.5 ? '167, 139, 250' : '34, 211, 238'; // Brighter accents
            this.opacity = Math.random() * 0.6 + 0.3;
        }

        update() {
            this.x += this.vx;
            this.y += this.vy;

            // Bounce off edges smoothly
            if (this.x < 0 || this.x > width) this.vx *= -1;
            if (this.y < 0 || this.y > height) this.vy *= -1;

            // Mouse interaction: move slightly away or highlight
            if (mouse.x != null && mouse.y != null) {
                let dx = mouse.x - this.x;
                let dy = mouse.y - this.y;
                let distance = Math.sqrt(dx * dx + dy * dy);
                if (distance < mouse.radius) {
                    this.opacity = 1; // Highlight when close to mouse
                } else {
                    this.opacity = Math.max(0.3, this.opacity - 0.05); // fade back
                }
            } else {
                 this.opacity = Math.max(0.3, this.opacity - 0.01);
            }
        }

        draw() {
            ctx.beginPath();
            ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
            ctx.fillStyle = `rgba(${this.baseColor}, ${this.opacity})`;
            ctx.fill();
        }
    }

    function initParticles() {
        particles = [];
        // calculate number of particles based on screen size, max 100
        const numberOfParticles = Math.min(Math.floor((width * height) / 10000), 150);
        for (let i = 0; i < numberOfParticles; i++) {
            particles.push(new Particle());
        }
    }

    function connect() {
        let opacityValue = 1;
        for (let a = 0; a < particles.length; a++) {
            for (let b = a; b < particles.length; b++) {
                let dx = particles[a].x - particles[b].x;
                let dy = particles[a].y - particles[b].y;
                let distance = dx * dx + dy * dy;
                
                // Draw lines between close particles
                if (distance < 15000) {
                    opacityValue = 1 - (distance / 15000);
                    ctx.strokeStyle = `rgba(167, 139, 250, ${opacityValue * 0.5})`;
                    ctx.lineWidth = 1;
                    ctx.beginPath();
                    ctx.moveTo(particles[a].x, particles[a].y);
                    ctx.lineTo(particles[b].x, particles[b].y);
                    ctx.stroke();
                }
            }
        }
    }

    function animate() {
        ctx.clearRect(0, 0, width, height);
        particles.forEach(p => {
            p.update();
            p.draw();
        });
        connect();
        requestAnimationFrame(animate);
    }
    
    resize();
    animate();
}
